import React from 'react';
import { Card, CardContent } from '../ui/card';
import { CenteredColumn } from './CenteredColumn';
import { StyledBackLinkWithTitle } from '../../z40-uicomp/back-link-with-title';
import { SpaceBottom } from '../../z40-uicomp/layout';
import { translate } from '@soap/modules';
import robot from '../../z30-images/robot-s.png';
import { cn } from '../lib/utils';

interface CenteredCardProps {
  children: React.ReactNode;
  showRobot?: boolean;
  title?: React.ReactNode;
  onBack?: () => void;
  backText?: string;
  maxWidth?: number;
  backgroundColor?: string;
  className?: string;
}

export function CenteredCard({ 
  children, 
  showRobot = true, 
  title, 
  onBack, 
  backText = "Back", 
  maxWidth = 500, 
  backgroundColor,
  className 
}: CenteredCardProps) {
  return (
    <CenteredColumn sidePadding={0} backgroundColor="transparent">
      <div className="w-full">
        <div 
          className="mx-auto"
          style={{ maxWidth: `${maxWidth}px` }}
        >
          <Card 
            className={cn(
              "p-6 rounded-md overflow-auto",
              className
            )}
            style={{ backgroundColor }}
          >
            <CardContent className="p-0">
              {title && (
                <SpaceBottom>
                  <div className="flex justify-between items-center">
                    {onBack && (
                      <StyledBackLinkWithTitle 
                        onPress={onBack}
                        title={backText}
                      />
                    )}
                    <div className="w-full flex justify-center">
                      {title}
                    </div>
                    {showRobot && (
                      <img 
                        src={robot} 
                        width={40} 
                        height={40} 
                        alt={translate("Learn Your Way Robot")}
                      />
                    )}
                  </div>
                </SpaceBottom>
              )}
              <CenteredColumn>
                {children}
              </CenteredColumn>
            </CardContent>
          </Card>
        </div>
      </div>
    </CenteredColumn>
  );
}

export function SlimCard({ 
  children, 
  backgroundColor, 
  title, 
  className,
  ...rest 
}: {
  children: React.ReactNode;
  backgroundColor?: string;
  title?: React.ReactNode;
  className?: string;
  [key: string]: any;
}) {
  return (
    <Card 
      className={cn(
        "p-6 rounded-md overflow-auto",
        className
      )}
      style={{ backgroundColor }}
      {...rest}
    >
      <CardContent className="p-0">
        {title}
        {children}
      </CardContent>
    </Card>
  );
}
